<div class="zentra-admin-success-dialog">
  <h1 mat-dialog-title>Confirm Delete</h1>

  <div mat-dialog-content class="message">
    <h3>Are you sure you want to delete this trial subscription?</h3>
  </div>

  <div mat-dialog-actions class="actions">
    <div class="buttons">
      <button mat-raised-button color="primary" mat-dialog-close="cancel">
        No - Go Back
      </button>
      <button mat-raised-button color="warn" mat-dialog-close="confirm">
        Yes - Delete
      </button>
    </div>
  </div>
</div>
